@if (visible && matchedTask) {
  <div
    class="workflow-url-float"
    [style.transform]="'translate(' + dragX + 'px,' + dragY + 'px)'"
    >
    <div
      class="workflow-url-float__header"
      (mousedown)="startDrag($event)"
      role="banner"
      >
      <span class="workflow-url-float__title">{{ matchedTask.title }}</span>
      <button
        type="button"
        class="btn-close btn-close-sm"
        [attr.aria-label]="'PROJECT_MANAGEMENT.URL_TASK_FLOAT_DISMISS' | translate"
        (click)="dismiss($event)"
      ></button>
    </div>
    @if (matchedTasks.length > 1) {
      <div class="workflow-url-float__tabs">
        @for (task of matchedTasks; track task; let i = $index) {
          <button
            type="button"
            class="workflow-url-float__tab"
            [class.workflow-url-float__tab--active]="i === activeTaskIndex"
            [class.workflow-url-float__tab--completed]="isTaskCompleted(task)"
            (click)="selectTaskTab(i)"
            >
            {{ i + 1 }}. {{ task.title }}
          </button>
        }
      </div>
    }
    <div class="workflow-url-float__body">
      @if (matchedTask.taskDescription) {
        <div
          class="workflow-url-float__desc"
          [ngbTooltip]="matchedTask.taskDescription"
          placement="top"
          container="body"
          >
          {{ matchedTask.taskDescription }}
        </div>
      }
      <label class="form-label small text-muted mb-1 d-block">{{
        "PROJECT_MANAGEMENT.TASK_STATUS" | translate
      }} </label>
      <select
        class="form-select form-select-sm pm-task-inline-select"
        [(ngModel)]="selectedStatus"
        [ngClass]="taskStatusSelectClass(selectedStatus)"
        [disabled]="saving || isMatchedProjectCompleted()"
        >
        @for (s of statusOptions; track s) {
          <option
            [ngValue]="s"
            [ngStyle]="taskStatusOptionStyle(s)"
            >
            {{ taskStatusLabel(s) }}
          </option>
        }
      </select>
      <div class="workflow-url-float__actions">
        <button
          type="button"
          class="btn btn-sm btn-primary"
        [disabled]="
          saving ||
          isMatchedProjectCompleted() ||
          !selectedStatus ||
          selectedStatus === matchedTask.status
        "
          (click)="applyStatus()"
          >
          {{ "PROJECT_MANAGEMENT.URL_TASK_FLOAT_APPLY" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-success"
          [disabled]="saving || isMatchedProjectCompleted() || isCompleted()"
          (click)="markCompleted()"
          >
          {{ "PROJECT_MANAGEMENT.URL_TASK_FLOAT_DONE" | translate }}
        </button>
      </div>
      <p class="workflow-url-float__hint mb-0">
        <span class="text-warning">** </span> {{ "PROJECT_MANAGEMENT.URL_TASK_FLOAT_HINT" | translate }}
      </p>
    </div>
  </div>
}
